/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Hide price on product item',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try {
          // Start customization--------------------------------------------
					let productData = element.getParams().props.product;
					let productId = productData.id;
					if (productData?.split_product) {
        			    productId = productData.variant_id;
					}
                     console.log(productData);
					let productItem = document.querySelector('[data-product-id="' + productId + '"]');
					if (productItem) {
						if (productData.price_min == 0) {
                          productItem.classList.add('hidden-price');
                        }
					}
          // End-------------------------------------------------------------
          } catch (e) {
	          console.error(e) ;
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);